import { Box, CSSProp, Text } from '@streamelements/frontend-ui';
import { PropsWithChildren } from 'react';

export function UnknownError({ children, css }: PropsWithChildren<CSSProp>) {
  return (
    <Box
      css={{
        size: '100%',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
        ...css,
      }}
    >
      <Text.Heading weight="bold" level="5">
        Oh uh...
      </Text.Heading>
      <Text.Body css={{ color: '$textPrimary50' }}>
        A technical error occurred on our end. Please try again later.
      </Text.Body>
      {children}
    </Box>
  );
}
